// DO NOT MODIFY, this file is autogenerated by tools/build.ts
import { ɵzoneWrap } from '@angular/fire';
import {
  authState as _authState,
  idToken as _idToken,
  user as _user
} from 'rxfire/auth';

export const authState = ɵzoneWrap(_authState, true);
export const idToken = ɵzoneWrap(_idToken, true);
export const user = ɵzoneWrap(_user, true);
